@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../respond-to.scss';
@import '../../global-styles/index.scss';

:host {
  position: relative;
  // override bad stlying from Catalog; TODO: remove this from Catalog after test
  min-height: unset !important;
  z-index: 300;
  .ciHeader {
    display: grid;
    grid-template-columns: auto 1fr auto auto;
    grid-template-areas:
      "logo search accounts cart";
    justify-content: center;
    align-items: center;
    z-index: 100;
    padding: 0 $spacing-16;
    @include breakpoint('lg','xl') {
      padding: 0 0;
    }
    margin: auto;
    box-sizing: border-box;
    customer-chat,customer-contact {
      display: none;
    }
    &:has(ci-search) {
      grid-template-areas:
        "logo . accounts cart"
        "search search search search";
      grid-template-columns: auto 1fr auto auto;
      grid-template-rows: repeat(2, auto);
      #customer-btn {
        display: none;
      }

      @media only screen and (max-width: 699px) {
        grid-template-rows: 56px 48px;
      }
      @include breakpoint('md','lg','xl') {
        column-gap: 16px;
        grid-template-rows: 64px;
      }
    }
  }
  .banner-title--desktop{
    display: none;
  }
  ci-cart::part(text) {
    display: none;
  }
  .ciHeader-accounts-btn-popup {
    display: flex;
    flex-direction: column;
    gap: 0px;
    background: none;
    min-height: 40px;
    padding: 0 8px;
    border-radius: 6px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    border: none;
    padding: 0px;
    font-family: $typography-family;
    font-size: var(--typography-button-small-size, 12px);
    color: #4A4A4A;
  }

  @include breakpoint('md','lg','xl') {
    .ciHeader-accounts-btn-popup {
      display: inline-flex;
      flex-direction: row;
      gap: 08px;
      margin-left: 0px;
      font-size: 16px;
    }
  }

  // disabled state of ciHeader-accounts-btn
  .ciHeader-accounts-btn-popup[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .ciHeader-accounts-btn-text--mobile {
    display: none;
  }
  .simple {
    padding: 0 $spacing-16;
    grid-template-rows: 60px;
    grid-template-columns: 1fr repeat(3, 50px) auto;
    grid-template-areas:
      "logo help accounts cart";
    .ciHeader-accounts-btn-text--mobile {
      display: block;
    }
    .ciHeader-accounts-btn-text {
      display: none;
    }
    @include breakpoint('xs','sm') {
      ci-cart,.ciHeader-accounts-btn-popup {
        justify-self: center;
      }
      .customer-help {
        display: unset;
        width: auto;
        justify-self: center;
      }
    }
    @include breakpoint('md','lg','xl') {
      column-gap: 16px;
      grid-template-columns: 1fr auto auto auto;
      .ciHeader-accounts-btn-text--mobile {
        display: none;
      }
      .ciHeader-accounts-btn-text {
        display: block;
      }
    }

    .ciHeader-mobile-menu-btn,ci-mobile-subnav{
      display: none;
    }
    #customer-btn {
      display: flex;
      flex-direction: column;
      border: none;
      background: none;
      padding: 0;
      span {
        color: #4a4a4a;
        font-size: var(--typography-button-small-size, 12px);
        font-family: $typography-family;
      }
      img {
        width: 24px;
        height: 24px;
      }
      @include breakpoint('md','lg','xl') {
        display: none;
      }
    }
    customer-chat,customer-contact {
      @include breakpoint('md','lg','xl') {
        display: block;
      }
    }
    .customer-actions {
      @include breakpoint('md','lg','xl') {
        display: none;
      }
      customer-chat,customer-contact {
        display: block;
      }
    }
    @media only screen and (max-width: 699px) {
      ci-cart {
        justify-self: center;
      }
      ci-cart::part(text) {
        display: block;
        font-size: var(--typography-button-small-size, 12px);
        color: #4a4a4a;
      }
      .ciHeader-accounts-btn{
        display: flex;
        flex-direction: column;
        padding: 0;
        gap: 0px;
        flex: 1;
      }
    }
  }
  ci-search{
    grid-area: search;
    justify-self: center;
  }
  .customer-help {
    display: flex;
    gap: 16px;
    grid-area: help;
    width: 100%;
    #customer-subtitle {
      margin: 0px;
      font-weight: 500;
      font-size: 16px;
      line-height: 1.25;
      letter-spacing: 0px;
      font-family: "Sharp Sans", Helvetica, Arial, "Trebuchet MS", sans-serif;
    }

    .customer-actions {
      display: flex;
      flex-direction: column;
      -webkit-box-pack: start;
      justify-content: flex-start;
      flex: 0 0 auto;
      gap: 8px;
      --color-svg: #1E39D2;
      --color-subtitle: #1E39D2;
      --typography-button-medium-size: 16px;

      a,button {
        box-sizing: border-box;
        border-radius: 6px;
        width: 100%;
        height: 44px;
        font-size: 14px;
        line-height: 18px;
        display: flex;
        align-items: center;
        color: #fa3c00;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        border: 1px solid var(--interactive-border-bold, #1E39D2);
        background: var(--neutral-background-primary, #FFF);
      }
    }
  }
  .ciHeader-subNav{
    grid-area: logo;
    gap: 0;
  }
  .accounts {
    position: relative;
    grid-area: accounts;
    width: 100%;
    &:hover {
      .ciHeader-accounts-btn{
        color: $color-blue-default;
        background: $color-header-hover-blue;
        &:link,
        &:visited {
          color: $color-blue-default;
        }
        svg,
        path {
          fill: $color-blue-default;
        }
      }
    }
    span {
      white-space: nowrap;
    }
    a {
      min-height: 40px;
      padding: 0 8px;
      border-radius: 6px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border: none;
      gap: 8px;
      text-decoration: none;
      font-size: var(--typography-button-small-size, 12px);
      height: 100%;
      position: relative;
      line-height: 1.333;
      white-space: nowrap;
      &:link,
      &:visited {
        color: $color-gray-slate-default;
      }
      &:hover {
        background: $color-header-hover-blue;
        color: $color-blue-default;
        svg,
        path {
          fill: $color-blue-default;
        }
      }
    }
  }
  ci-cart {
    grid-area: cart;
    justify-self: end;
    align-items: center;
  }
  ci-navigation{
    grid-area: navigation;
  }
  .main-container {
    position: relative;
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    background-color: #fff;
    box-sizing: border-box;
  }

  .navigation {
    margin: auto;
    box-sizing: border-box;
    ci-navigation {
      box-sizing: border-box;
    }
  }
  .banner-container {
    width: 100%;
    background-color: $color-red-default;
    position: relative;
    --fill-text: #{$color-shade-white};
    .banner {
      margin: auto;
      padding: 0 $spacing-16;
      color: var(--fill-text, $color-shade-white);
      margin: auto;
      height: $spacing-32;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: $spacing-16;
      font-size: $typography-caption-caption-regular-size;
      justify-content: space-between;
      box-sizing: content-box;
      height: 32px;
      &-title {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        flex: 1;
        min-width: 0;
        color: var(--fill-text);
      }
      &-actions {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        padding: 0;
        gap: $spacing-16;
        height: 100%;
        margin-right: -16px;
        flex-shrink: 0;
        @media (max-width: 1023px) {
          margin-right: 0;
        }
      }
      @media only screen and (min-width: 1024px) {
        .ciHeader:not(.simple) {
          customer-chat,
          customer-contact {
            display: none;
          }
        }
      }
    }
    &--withAd {
      background: white;
      border-bottom: 1px solid $color-gray-accent;
      --fill-text: #{$color-gray-slate-default};
      .bannerAd {
        background: #a639b2;
        color: white;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 125%;
        text-align: center;
        line-height: 52px;
        height: 52px;
        @media only screen and (max-width: 699px) {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          flex: 1 0 0;
        }
        &-text {
          @media only screen and (max-width: 699px) {
            color: var(--neutral-text-primaryOnFill, #FFF);
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 125%;
            width: 230px;
          }
        }
        &-cta {
          flex: 1 0 0;
          color: var(--neutral-text-primaryOnFill, #FFF);
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          line-height: 16px;
          text-decoration: none;
          box-sizing: border-box;
          display: inline-flex;
          min-width: 64px;
          min-height: 32px;
          padding: 6px 16px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: var(--radius-button, 6px);
          border: 1px solid white;
          background: transparent;
          margin-left: 16px;
          white-space: nowrap;
          &:hover {
            color: var(--Passion-Purple-Default, var(--primitives-color-brand-passionPurple-core, #A639B2));
            border: 1px solid var(--interactive-border-strongOnFill, #FFF);
            background: #FFF;
          }
        }
      }
    }
  }

  .main-container {
    width: 100%;
  }
  .navigation-container {
    width: 100%;
    position: relative;
    display: none;
    border-bottom: 1px solid $color-gray-accent;
    background-color: $color-shade-white;
    height: 50px;
    box-sizing: border-box;
  }

  .navigation {
    display: grid;
    grid-template-columns: 1fr auto auto;
    grid-template-areas: "navigation accounts cart";
    justify-content: space-between;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    padding: 4px 0px;
    ci-navigation {
      flex: 1;
      justify-self: start;
    }
    .ciHeader-accounts, ci-cart {
      align-items: center;
      margin-right: -10px;
    }
  }

  .overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    visibility: hidden;
    opacity: 0;
    transition: all 0.15s ease-out;
    &.activeOverlay {
      visibility: visible;
      opacity: 1;
    }
  }
  .ciHeader {
    z-index: 100;
    flex-direction: column;

    // This CSS is just for SB apps, otherwise the button looks funny due to missing font.
    .ghf-text-button,
    .ghf-primary-button,
    .ghf-secondary-button {
      font-family: SharpSans, Sharp Sans, Helvetica, Arial, 'Trebuchet MS', sans-serif;
    }

    width: 100%;
    margin: 0 auto;

    &-main-container {
      width: 100%;
      background-color: $color-shade-white;
      border-bottom: 1px solid $color-gray-accent;
    }

    &-main {
      display: flex;
      height: $spacing-48;
      &-wrapper {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        height: 100%;
        box-sizing: content-box;
        gap: 4px;
        @media only screen and (min-width: 700px) {
          gap: $spacing-32;
        }
      }
    }

    &-subNav {
      display: flex;
      flex-direction: row;
      gap: 0;
    }
    &-mobile-menu-btn {
      cursor: pointer;
      align-self: center;
      display: flex;
      flex-direction: column;
      gap: 3px;
      padding: 14px 11px;
      margin-left: -8px;
      margin-right: 4px;
      span {
        background: black;
        border-radius: 3px;
        content: '';
        width: 18px;
        height: 2px;
      }
    }
    &-logo {
      align-self: center;
      &-image {
        height: 40px;
        display: block;
        @include breakpoint('lg','xl') {
          height: 48px;
        }
      }
    }
    @media only screen and (min-width: 1024px) {
      .ciHeader-mobile-menu-btn,ci-mobile-subnav{
        display: none;
      }
    }
  }

  // simple customer support
  .ciHeader-CustomerSupport {
    display: flex;
    gap: 16px;
    flex-shrink: 0;

    &-divider {
      @media only screen and (max-width: 699px) {
        display: none;
      }
      border: 0.5px solid $color-gray-accent;
      margin: 3px 0;
    }
  }

  // TTARP mobile in red bar
  .banner-ttarpMobile {
    display: flex;
    height: 100%;
    cursor: pointer;
    text-decoration: none;
    color: var(--fill-text);
    &:link,
    &:visited,
    &:hover {
      color: var(--fill-text);
    }
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    @include breakpoint('lg','xl') {
      display: none;
    }
  }

  @include breakpoint('lg') {
    .banner-actions {
      margin: 0;
    }
    .ciHeader {
      height: 63px;
      &-main {
        height: 100%;
        &-wrapper {
          align-items: center;
          justify-content: space-between;
          padding: 4px $spacing-16;
          box-sizing: border-box;
        }
        &-image {
          &--mobile {
            display: none;
          }
          &--desktop {
            display: block;
            height: 50px;
          }
        }
      }
      &-logo-image {
        height: 48px;
      }
      &-subNav {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
    .navigation-container {
      display: block;
    }
    .navigation,.ciHeader:not(.simple),.banner{
      max-width: 976px;
    }
  }

  @include breakpoint('xl') {
    .navigation-container {
      display: block;
    }
    .banner-actions {
      margin: 0;
    }
    .banner-actions--desktop {
      display: flex;
      min-width: 526px;
    }
    .navigation,.ciHeader:not(.simple),.banner{
      max-width: 1252px;
    }

    .ciHeader {
      &-main {
        height: 100%;
        &-wrapper {
          max-width: 1252px;
          margin: auto;
          justify-content: space-between;
          padding: 4px 0;
          box-sizing: border-box;
        }
      }
    }
  }
  @media only screen and (min-width: 1024px) {
    .banner-title--mobile,
    .banner-actions--mobile {
      display: none;
    }
    .banner-title--desktop{
      display: block;
    }
    .ciHeader-main {
      ci-navigation-rightside {
        display: none;
      }
    }
  }

  .ciHeader:not(.simple) {
    .customer-help {
      @include breakpoint('md') {
        display: none;
      }
    }
  }
  @media (min-width: 700px) {
    .ciHeader:not(.simple) {
      grid-template-areas:
        "logo search accounts cart";
      grid-template-columns: auto 1fr auto auto;
    }
  }
  @media (min-width: 1024px) {
    .ciHeader:not(.simple) {
      grid-template-areas:
        "logo search help";
      grid-template-columns: auto 1fr auto;
      ci-cart, .accounts {
        display: none;
      }
      customer-contact,
      customer-chat {
        display: flex;
        justify-self: center;
      }
    }
  }
}

